import { lengthUnits } from './length';
import { massUnits } from './mass';
import { volumeUnits } from './volume';
import { timeUnits } from './time';
import { calendarUnits } from './calendar';
import { fuelEconomyUnits } from './fuelEconomy';
import { temperatureUnits } from './temperature';
import { textileUnits } from './textile';
import { forceUnits } from './force';
import { powerUnits } from './power';
import { energyUnits } from './energy';
import { countUnits } from './count';
import { carbonUnits } from './carbon';
import { currencyUnits } from './currency';
import { informationUnits } from './information';
import { areaUnits } from './area';
import { storageUnits } from './storage';
import { energyEconomyUnits } from './energyEconomy';

export const allUnits = [
  ...lengthUnits,
  ...massUnits,
  ...volumeUnits,
  ...timeUnits,
  ...calendarUnits,
  ...fuelEconomyUnits,
  ...temperatureUnits,
  ...textileUnits,
  ...powerUnits,
  ...energyUnits,
  ...forceUnits,
  ...currencyUnits,
  ...informationUnits,
  ...countUnits,
  ...carbonUnits,
  ...areaUnits,
  ...storageUnits,
  ...energyEconomyUnits,
];
